
import { supabase } from "@/integrations/supabase/client";

// Generate voice message using ElevenLabs
export const generateVoiceMessage = async (text: string, voiceId?: string): Promise<{ success: boolean; audioUrl?: string; audioBase64?: string; error?: string }> => {
  try {
    console.log(`Generating voice message with text: "${text.substring(0, 50)}..." and voiceId: ${voiceId || 'default'}`);
    
    const { data, error } = await supabase.functions.invoke("generate-voice", {
      body: { text, voiceId },
    });

    if (error) throw error;
    if (!data.success) throw new Error(data.error || "Failed to generate voice message");

    return { 
      success: true, 
      audioUrl: data.audioUrl,
      audioBase64: data.audioBase64
    };
  } catch (error) {
    console.error("Error generating voice message:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "An unknown error occurred" 
    };
  }
};

// Play a base64-encoded audio
export const playAudioFromBase64 = (base64Audio: string): HTMLAudioElement => {
  const audio = new Audio(`data:audio/mp3;base64,${base64Audio}`);
  audio.play();
  return audio;
};

// Get the list of available voices from ElevenLabs
export const fetchAvailableVoices = async (): Promise<{ success: boolean; voices?: any[]; error?: string }> => {
  try {
    const { data, error } = await supabase.functions.invoke("list-voices", {
      body: {},
    });

    if (error) throw error;
    if (!data.success) throw new Error(data.error || "Failed to fetch available voices");

    return { 
      success: true, 
      voices: data.voices
    };
  } catch (error) {
    console.error("Error fetching available voices:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "An unknown error occurred" 
    };
  }
};

// Preview a voice without saving it
export const previewVoice = async (voiceId: string, text?: string): Promise<{ success: boolean; audioBase64?: string; error?: string }> => {
  try {
    const sampleText = text || "Hello, I'm calling from the dealership about your recent interest in our vehicles. Is this a good time to talk?";
    
    const result = await generateVoiceMessage(sampleText, voiceId);
    
    if (!result.success) {
      throw new Error(result.error || "Failed to generate voice preview");
    }
    
    return { 
      success: true, 
      audioBase64: result.audioBase64
    };
  } catch (error) {
    console.error("Error previewing voice:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "An unknown error occurred" 
    };
  }
};

// Load available voice models from ElevenLabs
export const fetchVoiceModels = async (): Promise<{ success: boolean; models?: any[]; error?: string }> => {
  try {
    const { data, error } = await supabase.functions.invoke("list-voice-models", {
      body: {},
    });

    if (error) throw error;
    if (!data.success) throw new Error(data.error || "Failed to fetch available voice models");

    return { 
      success: true, 
      models: data.models
    };
  } catch (error) {
    console.error("Error fetching voice models:", error);
    return { 
      success: false, 
      error: error instanceof Error ? error.message : "An unknown error occurred" 
    };
  }
};
